import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {InstructionsState} from '../../../interfaces/reducers/Instructions';

const initialState: InstructionsState = {};

export const onboardingSlice = createSlice({
  name: 'onboarding',
  initialState,
  reducers: {
    setIsOnboardingSeen: (state, action: PayloadAction<InstructionsState>) => {
      state.isSeen = action.payload.isSeen;
    },
  },
});

// Action creators are generated for each case reducer function
export const {setIsOnboardingSeen} = onboardingSlice.actions;

export default onboardingSlice.reducer;
